import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { overrideCSS } from '../../utils/function';

const internalStyles = require('./Tooltip.pcss');

interface IState {
    visible: boolean;
}

interface IProps {
    text?: any;
    onClick?: any;
    styles?: Object;
}

export class Tooltip extends React.Component<IProps, IState>{
    constructor(props) {
        super(props);

        this.state = { visible: false };
        this.toggle = this.toggle.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    toggle(event?) {
        event.stopPropagation();
        this.setState({ visible: !this.state.visible }, () => {
            this.handleProps();
        });
    }

    componentWillMount() {
        this.handleProps();
    }

    handleProps() {
        if (this.state.visible) {
            this.addEvents();
        } else {
            this.removeEvents();
        }
    }

    addEvents() {
        document.addEventListener('click', this.handleDocumentClick, true);
    }

    removeEvents() {
        document.removeEventListener('click', this.handleDocumentClick, true);
    }

    handleDocumentClick(e) {
        const container = ReactDOM.findDOMNode(this);

        if (container.contains(e.target) && container !== e.target) {
            return;
        }

        this.toggle(e);
    }

    render() {
        let styles = this.props.styles ? overrideCSS(internalStyles, this.props.styles) : internalStyles,
            visibility = this.state.visible ? styles.active : '';
        let internalClasses = {
            tooltipActive: `${styles.tooltip} ${visibility}`,
            tooltipBodyActive: `${styles.tooltipBody} ${visibility}`
        };
        let { text } = this.props;

        return (
            <span className={internalClasses.tooltipActive}>
                <svg
                    onClick={this.toggle}
                    className={styles.icon}
                    x="0px"
                    y="8px"
                    width="17px"
                    height="17px"
                    viewBox="0 0 510 510">
                    <path className={styles.iconPath} d="M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M280.5,382.5h-51v-153h51V382.5z M280.5,178.5h-51v-51h51V178.5z" />
                </svg>

                <span className={internalClasses.tooltipBodyActive}>
                    <span className={styles.tooltipClose} onClick={this.toggle}>
                        <svg width="15px" height="15px" viewBox="0 0 40 40"><path d="M 10,10 L 30,30 M 30,10 L 10,30" /></svg></span>
                    {text}
                </span>
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/Tooltip/Tooltip.tsx